/* globals Microsoft, define */
/*
  Purpose:updateStoreTitle
    - Module for the store finder dropdown and all it's interactions

  Dependencies:
    - jQuery
    - Mustache
    - THD Namespace
    - Microsoft
    - jQuery fancybox
*/
(function closure(root, factory) {
  if (typeof define === "function" && define.amd) {
    define("header.storefinder.inline", [
      "jquery",
      "body-scroll-lock",
      "Localizer",
      "hfConfig",
      "localization-drawer"
    ], function load(
      jQuery,
      bodyScrollLock,
      Localizer,
      hfConfig,
      localizationDrawer
    ) {
      return factory(
        root,
        jQuery,
        bodyScrollLock,
        Localizer,
        hfConfig,
        localizationDrawer
      );
    });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /* eslint-disable */
    var _hfapp = THD.Utility.Namespace.createNamespace("THD.HFApp");
    _hfapp.storeFinder = factory(
      root,
      jQuery,
      Localizer,
      THD.HFApp.storeFinderCommon,
      hfConfig
    );
    /* eslint-enable */
  }
})(this, function factory(
  root,
  $,
  bodyScrollLock,
  Localizer,
  hfConfig,
  localizationDrawer
) {
  var storeFinder = {};
  var privateMethods = {};
  var privateData = {};
  var drawerElement = document.querySelector("#myStore-overlay");

  privateMethods.setDrawerElement = function _setDrawerElement() {
    privateData.drawerElement = document.querySelector("#myStore-overlay");
  }

  privateMethods.updateStoreTitle = function _updateStoreTitle(event, html) {
    var redirectUrl = `//${hfConfig.nonSecureHostName}/l/?URL=${hfConfig.currentUrl}`;
    $("#myStoreMobile")
      .find(".MyStore__button")
      .attr("href", redirectUrl)
      .find(".MyStore__label")
      .html(html)
      .find(".MyStore__store")
      .addClass("MyStore__store--inline");
  };

  privateMethods.closeDrawer = function _closeDrawer({ keepMask }) {
    if (privateData.isDrawerOpen) {
      $("#myStore-wrapper").removeClass("myStore-mask");
      $('.caret__myStore').removeClass('caret__open');
      $("#myStore-overlay").addClass("u--hide");
      privateData.isDrawerOpen = false;
      bodyScrollLock.enableBodyScroll(privateData.drawerElement);
      if (!keepMask) {
        $(document).trigger("headerMask-show", false);
      }
    }
  };

  privateMethods.openDrawer = function _openDrawer() {
    const localizationDrawerInstance = new localizationDrawer.default({
      channel: 'mobile',
      hostName: THD_GLOBAL.nonSecureHostName,
      selectedStoreId: privateData.myStore.storeId
    });
    // to hide deliveryzip while opening the store finder
    const tooltipEnabled = $('#deliveryZipDropdown').hasClass('hidden');
    if (!tooltipEnabled){
      $( "#zipContainer a" ).click();
    }
    localizationDrawerInstance.createDrawer();
    privateData.isDrawerOpen = true;
    $(document).trigger("headerMask-show", true);
    bodyScrollLock.disableBodyScroll(privateData.drawerElement);
    
    $('.caret__myStore').addClass('caret__open');
    $('.caret__deliveryZip').removeClass('caret__open');
  }

  privateMethods.toggleDrawer = function _toggleDrawer(event, open) {
    event.preventDefault();
    event.stopPropagation();
    var drawerOpen =
      typeof open === "undefined" ? privateData.isDrawerOpen : !open;
    if (drawerOpen) {
      privateMethods.closeDrawer({ keepMask: false });
    } else {
      $("#not-your-store").addClass("u--hide");
      privateMethods.openDrawer();
    }
  };

  /*
   * Public Methods
   */
  storeFinder.init = function _init() {
    privateMethods.setDrawerElement();

    Localizer.localize()
      .then(function(response) {
        privateData.myStore = response.getLocalizedStore() || {
          storeId: "0121"
        };
        $(document).ready(function() {
          $("#myStoreMobile, #js-change-store-href").on(
            "click touchend",
            privateMethods.toggleDrawer
          );
        });
      })
      .catch(function(err) {
        console.warn(err);
      });

    $(document)
      .on("updateStoreTitle", privateMethods.updateStoreTitle)
      .on("closeDrawer", privateMethods.toggleDrawer)
      .on("click touchend", "#simpleMenuButton", function(event) {
        privateMethods.closeDrawer({ keepMask: true })
      })
      .on("click touchend", "#myAccountProfileButton", function(event) {
        privateMethods.closeDrawer({ keepMask: true })
      })
      .on("searchState", privateMethods.closeDrawer);

    return this;
  };

  storeFinder.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  storeFinder.getPrivateData = function getPrivateData() {
    return privateData;
  };
  return storeFinder;
});
